export default "__VITE_ASSET__WYwSnliD__"